<ng-template #volumeBarMaxTextTpl>
	<p>100</p>
</ng-template>

<div class="w-full flex flex-col items-start justify-start">
	<audio
		#audio
		class="w-full hidden"
		[src]="$fileUrl()"
		controls
		loop
		crossorigin="use-credentials"
		(pause)="onPause()"
		(play)="onPlay()"
		(ended)="onEnded()"
		(error)="onError()"
		(onloadedmetadata)="onLoadedMetadata()"
		(durationchange)="onDurationChange()"
		(timeupdate)="onTimeUpdate()"
		(volumechange)="onVolumeChange()"
	></audio>

	<div class="overflow-hidden w-full h-0 flex items-center justify-start">
		<div #volumeBarMaxText>
			<ng-container [ngTemplateOutlet]="volumeBarMaxTextTpl"></ng-container>
		</div>
	</div>

	<div class="py-2 px-3 rounded-1.5 gap-2 w-full bg-280 flex items-center justify-center">
		<div class="flex-none gap-0.5 flex items-center justify-start">
			<button class="fc-500" commonButtonIcon (click)="togglePlay()">
				<i
					[class.icon-bold-play-media]="!$playing()"
					[class.icon-bold-pause-media]="$playing()"
				></i>
			</button>

			<button class="fc-500" commonButtonIcon (click)="goBackwards()">
				<i class="icon-bold-backward-media"></i>
			</button>

			<button class="fc-500" commonButtonIcon (click)="goForward()">
				<i class="icon-bold-forward-media"></i>
			</button>

			<div
				class="flex items-center justify-start volume-wrapper"
				[class.show-content]="$draggingVolume()"
				[class.allow-hover]="!$draggingTime()"
				[style.--aux-volume-width.px]="volumeBarMaxText.clientWidth"
			>
				<button class="fc-500" commonButtonIcon (click)="toggleMute()">
					<i [class.icon-volume]="!$muted()" [class.icon-volume-muted]="$muted()"></i>
				</button>

				<div class="overflow-hidden flex items-center justify-start volume-content">
					<div class="flex-none gap-1 flex items-center justify-start">
						<div
							#volumeBar
							class="rounded-0.25 flex-none h-0.5 bg-line-230 cursor-pointer flex relative items-center justify-start w-10"

						>
							<div
								class="rounded-0.25 h-full bg-primary"
								[style.width.%]="$volumeToShow()"
							></div>

							<div
								class="rounded-circle w-1.75 h-1.75 bg-primary absolute pointer-events-none top-1/2 [transform:translate(-50%,_-50%)]"

								[style.left.%]="$volumeToShow()"
							></div>
						</div>

						<div class="flex-none flex flex-col items-start justify-start">
							<div class="overflow-hidden h-0 invisible">
								<ng-container
									[ngTemplateOutlet]="volumeBarMaxTextTpl"
								></ng-container>
							</div>
							<p>{{ $volumeToShow() | number : '1.0-0' }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			#timerBar
			class="flex-auto overflow-hidden h-0.75 bg-line-230 cursor-pointer rounded-0.375"

		>
			<div
				class="h-full bg-primary rounded-0.375"
				[style.width.%]="($currentTime() / $maxTime()) * 100"

			></div>
		</div>

		<p class="flex-none">
			<span>{{ $currentTime() | audioPreviewTimestamp }}</span>
			<span>&nbsp;/&nbsp;</span>
			<span>{{ $maxTime() | audioPreviewTimestamp }}</span>
		</p>
	</div>
</div>
